export default __webpack_public_path__ + "static/media/my-trainging-h1.abb55c9d.svg";